// UserSession 保存キー
const USER_SESSION_SAVE_KEY = 'save_account'
// ログインユーザーオブジェクトをSession Storageに保存するためのキー
const SESSION_STORAGE_SAVE_KEY_LOGIN_USER_OBJ = 'save_login_user_obj';
// ドメイン
const DOMAIN = 0
// Aサイト
const DOMAIN_A_SITE = 0
// Bサイト
const DOMAIN_B_SITE = 1
// Cサイト
const DOMAIN_C_SITE = 2
// API
const API_FUNCTION_PHASE2 = 'usersite-prod-api-phase2'
// S3 バケット名
const BUCKET_NAME = {  
  CONTENTS: 'usersite-prod-contents', // 本番
  // CONTENTS: 'usersite-stg-contents', // ステージング    
  ICON: 'usersite-prod-icon', // 本番  
  // ICON: 'usersite-stg-icon', // ステージング
  PRODUCT: 'usersite-prod-product',  // 本番
  // PRODUCT: 'usersite-stg-product',  // ステージング  
}
// コンテンツ種別 PDF
const CONTENTS_TYPE_PDF = 0
// コンテンツ種別 画像
const CONTENTS_TYPE_IMAGE = 1
// コンテンツ種別 動画
const CONTENTS_TYPE_VIDEO = 2
// マイページ画面のパスワードの表記
const HIDE_PASSWORD = '**********'
// 通信成功時のエラーコード
const COMMUNICATION_SUCCESS = 1
// 登録成功
const SUCCESSFUL_REGISTRATION = '登録が完了しました'
// 登録失敗
const FAILED_REGISTRATION = '登録が失敗しました'
// ログインパスワード プレースホルダー
const PLACE_HOLDER_PASSWORD = '英数字8文字以上'
// 再登録 ユーザーID(メールアドレス) プレースホルダー
const PLACE_HOLDER_USER_ID = 'メールアドレスを入力'
// パスワード再登録エラーメッセージ
const RE_REGISTRATION_ERROR_MESSAGE = '8文字以上の英数字で入力してください'
// パスワード、パスワード(確認)
const RE_REGISTRATION_MISMATCH_ERROR_MESSAGE = 'パスワードが一致していません'
// メール送信依頼成功
const SUCCESSFUL_REQUEST_SEND_MAIL = 'メール送信が成功しました'
// メール送信依頼失敗
const FAILED_REQUEST_SEND_MAIL = '送信に失敗しました。下記のリンクよりお問い合わせください。'
// トークン発行失敗
const FAILED_ISSUE_TOKEN = 'トークンの発行に失敗しました'
// 登録されていないメールアドレスのためエラー
const FAILED_NOT_EMAIL_ADDRESS = '該当のメールアドレスが存在していません'
// ワンタイムトークン期限切れメッセージ
const TOKEN_EXPIRED_MESSAGE = '再登録が行われずに72時間が経過しました。再度メール送信から行ってください。'
// その他トークン照合エラー
const COLLATE_TOKEN_ERROR_MESSAGE = 'ワンタイムトークンの照合に失敗しました。ワンタイムトークンが存在しない可能性があります。'
// 初回パスワード変更完了通知
const SUCCESS_FIRST_TIME_CHANGE_PASSWORD = "初回パスワードの変更が完了しました。再度ログイン画面からログインを行ってください。";
// 初回パスワード変更失敗通知
const FAILED_FIRST_TIME_CHANGE_PASSWORD = "初回パスワードの変更に失敗しました。";
// 仮パスワード誤り
const TEMPORARY_PASSWORD_INCORRECT = "仮パスワードが間違っています";
// Cognito ログイン失敗 IDまたはパスワード不一致
const LOGIN_FAILED_CODE_NOT_AUTHORIZED = "NotAuthorizedException";

const RESPONSE_CODE_SUCCESS = 1
// エラーコード
const ERROR_CODE = {
  // 正常
  EMPTY: 'empty',
  // DB接続エラーコード
  DB_CONNECTION_ERROR: 'COM-01',
  // DBエラーコード
  DB_ERROR: 'COM-02',
  // トークン照合エラーコード
  COLLATE_TOKEN_ERROR: 'Q01-01',
  // トークン照合期限切れエラーコード
  EXPIRED_TOKEN_ERROR: 'Q01-02',
  // 存在しないメールアドレス
  NOT_EXIST_USER_ID_ERROR: 'Q01-03',

  // DB接続エラー
  COM_01: 'COM-01',  
  // DBエラー
  COM_02: 'COM-02',  

  //#region 商品一覧取得
  S02_01: 'S02-01', // 既にレスチレンの商品がカートに入っている
  S02_02: 'S02-02', // 既に消耗品の商品がカートに入っている
  S02_03: 'S02-03', // 既に院内ツールの商品がカートに入っている
  S02_04: 'S02-04', // 既にmiraDryの商品がカートに入っている
  S02_05: 'S02-05', // 既にSofwaveの商品がカートに入っている
  //#endregion

  //#region 注文内容確認
  // 代理店判定NG
  R01_01: 'R01-01',  
  R01_02: 'R01-02',
  // 存在しないクーポン
  R02_01: 'R02-01',  
  // 利用できないクーポン 対象外のユーザー
  R02_02: 'R02-02',
  // 利用できないクーポン 対象の商品がない
  R02_03: 'R02-03',
  //#endregion

  //#region 注文内容取得
  // カートがない
  S01_01: 'S01-01',  
  // 有効期限切れ
  S01_02: 'S01-02',
  //#endregion         

  //#region 注文申し込み     
  // 商品が全部0
  T01_01: 'T01-01',
  // 在庫数が超過
  T03_01: 'T03-01',
  // 在庫情報が存在しない
  T03_02: 'T03-02',
  //#endregion  
  // クリニックコードが存在しない
  U01_01: 'U01_01'
}

const ERROR_MESSAGE = {
  // DB接続エラー  
  COM_01: 'DB接続エラー',
  // DBエラー  
  COM_02: 'DBエラー',

  //#region 商品一覧取得
  // 既にレスチレンの商品がカートに入っている
  S02_01: 'レスチレンの注文途中です。\nカート内を削除し、レスチレン以外の注文に進みますか？\n※レスチレン以外の注文に進む場合は、カート内のレスチレンが削除されます。ご注意ください。', 
  // 既に消耗品の商品がカートに入っている
  S02_02: '各種消耗品の注文途中です。\nカート内を削除し、各種消耗品以外の注文に進みますか？\n※各種消耗品以外の注文に進む場合は、カート内の各種消耗品が削除されます。ご注意ください。', 
  // 既に院内ツールの商品がカートに入っている
  S02_03: '治療パンフ・ポスターなどの注文途中です。\nカート内を削除し、治療パンフ・ポスター以外の注文に進みますか？\n※治療パンフ・ポスター以外の注文に進む場合は、カート内の治療パンフ・ポスターなどが削除されます。ご注意ください。', 
  // 既にmiraDryの商品がカートに入っている
  S02_04: 'miraDryの注文途中です。\nカート内を削除し、miraDry以外の注文に進みますか？\n※miraDry以外の注文に進む場合は、カート内のmiraDryが削除されます。ご注意ください。', 
  // 既にSofwaveの商品がカートに入っている
  S02_05: 'Sofwaveの注文途中です。\nカート内を削除し、Sofwave以外の注文に進みますか？\n※Sofwave以外の注文に進む場合は、カート内のSofwaveが削除されます。ご注意ください。', 
  //#endregion

  //#region 注文内容確認
  // 代理店判定NG  
  R01_01: '現在ご注文を承ることができません。\n恐れ入りますが、お問い合わせフォームよりご連絡ください。',
  // 請求ユーザー複数
  R01_02: '現在ご注文を承ることができません。\n恐れ入りますが、お問い合わせフォームよりご連絡ください。',
  // 存在しないクーポン  
  R02_01: '存在しないクーポンコードが入力されました。',
  // 利用できないクーポン 対象外のユーザー  
  R02_02: 'お客様では利用できないクーポンコードが入力されました。',
  // 利用できないクーポン 対象の商品がない  
  R02_03: 'クーポンが適用される商品が選択されておりません。',
  //#endregion

  //#region 注文内容取得
  // カートがない  
  S01_01: '注文内容がありません。',
  // 有効期限切れ
  S01_02: '注文確認の有効期限が切れました。',
  //#endregion         

  //#region 注文申し込み     
  // 商品が全部0  
  T01_01: '最低でも、1つの数量を入れてください。',
  // 在庫数が超過
  T03_01: 'の注文可能数を超過しています。',
  // 在庫情報が存在しない
  T03_02: 'の注文を承ることが出来ません。',
  //#endregion  
  COMMUNICATION_ERROR_MESSAGE: "通信に失敗しました",
  BILLING_USRE_NOT_FOUND: "請求ユーザーが存在しません",
  BILLING_USER_ERROR: "貴院とのお取引では、請求先が複数登録もしくは代理店取引のため、請求情報が表示されません。詳細は下部のお問い合わせフォームよりお問い合わせください",
  BILLING_USER_NOT_SELECTED: "請求先が選択されていないため、再度発注ボタンを押下してください",

  U01_01: '出庫先が存在しません',
  CLINIC_FAILED: "クリニックが存在しないか選択されていません。",
}

const STATUS_CODE_SUCCESS = 200;

const INPUT_ORDER_QUENTITY_VALUE = '6+'

// ソート月
const LAST_3_MONTHS = "過去3ヶ月"
const LAST_6_MONTHS = "過去6ヶ月"
const LAST_9_MONTHS = "過去9ヶ月"
const LAST_12_MONTHS = "過去12ヶ月"

const POSTAGE_REMARKS = {
  RESTYLANE: '1回のご注文数が5箱未満の場合は、全国一律1,500円（税抜）のご負担をお願いいたします。',
  VARIOUS_CONSUMABLES: '数量に関わらず送料は無料です。',  
  TREATMENT_PAMPHLETS_AND_POSTERS: '数量に関わらず送料は無料です。',
  MIRA_DRY: '数量に関わらず送料は無料です。',
  SOFWAVE: '数量に関わらず送料は無料です。'
}

const All_DOWNLOAD_MODAL_MESSAGE = "まとめてDLの準備を行います。\n完了次第登録されているメールアドレスへ\nDL用のメールが送られますので少々お待ちください。"

const DISPLAY_ITEM_LIST = {
  NONE: '全非表示',
  SOFWAVE: 'Sofwave',
  RESTYLANE: 'レスチレン',
  CONSUMABLES: '各種消耗品',
  PAMPHLET_POSTER: '治療パンフ・ポスターなど',
  MIRADRY: 'miraDry',
  WEBSHOP: '化粧品・美顔器など'
}
// ソート用の配列。表示順を返るときはここを入れ替える
const DISPLAY_ITEM_SORT = [
  'Sofwave', 'miraDry', 'レスチレン', '各種消耗品', '治療パンフ・ポスターなど', '化粧品・美顔器など'
]

// 商品種別
const PRODUCT_ITEM_TYPE = {  
  RESTYLANE: 0,
  CONSUMABLES: 1,
  PAMPHLET_POSTER: 2,
  MIRADRY: 3,
  SOFWAVE: 4,  
}

const COOKIE_SAVE_KEY = "save_cookie"

// プラクティスサポートお問い合わせ 送信成功時のメッセージ
const PRACTICE_SUPPORT_SEND_SUCCESS_MESSAGE = "お問い合わせを承りました。\n通常、３営業日以内（平日：月～金曜日）にご回答申し上げます。\n少々お待ちください。";
// プラクティスサポートに表示する対象機種
const PRACTICE_SUPPORT_MACHINE_LIST = [
  { id: 1, name: 'The Ruby Z1' },
  { id: 3, name: 'The Ruby nano_Q' },
  { id: 8, name: 'CO2 Esprit' },
  { id: 10, name: 'miraDry' },
  { id: 11, name: 'XTRAC' },
  { id: 12, name: 'VTRAC' },
  { id: 15, name: 'JTRAC' },
  { id: 16, name: 'Omnilux' },
  { id: 18, name: 're-Beau2' },
  { id: 25, name: 'LightWalker' },
  { id: 26, name: 'Forma Alpha' },
  { id: 49, name: 'StarWalker' },
  { id: 51, name: 'PQX ピコレーザー' },
  { id: 55, name: 'e.f. Fractional CO2 Laser' },
  { id: 57, name: 'FlexSys Fit' },
];
const PRACTICE_SUPPORT_HEADER = "使い方・臨床等のお問い合わせ"

const COSME_ICON_MODAL_MESSAGE = "ジェイメック取扱いコスメ製品の\n使用期限検索・画像ダウンロードサイトへ移動します";

export default {
  USER_SESSION_SAVE_KEY: USER_SESSION_SAVE_KEY,
  DOMAIN: DOMAIN,
  DOMAIN_A_SITE: DOMAIN_A_SITE,
  DOMAIN_B_SITE: DOMAIN_B_SITE,
  DOMAIN_C_SITE: DOMAIN_C_SITE,
  BUCKET_NAME: BUCKET_NAME,
  CONTENTS_TYPE_PDF: CONTENTS_TYPE_PDF,
  CONTENTS_TYPE_IMAGE: CONTENTS_TYPE_IMAGE,
  CONTENTS_TYPE_VIDEO: CONTENTS_TYPE_VIDEO,
  HIDE_PASSWORD: HIDE_PASSWORD,
  COMMUNICATION_SUCCESS: COMMUNICATION_SUCCESS,
  SUCCESSFUL_REGISTRATION: SUCCESSFUL_REGISTRATION,
  FAILED_REGISTRATION: FAILED_REGISTRATION,
  PLACE_HOLDER_PASSWORD: PLACE_HOLDER_PASSWORD,
  RE_REGISTRATION_ERROR_MESSAGE: RE_REGISTRATION_ERROR_MESSAGE,
  PLACE_HOLDER_USER_ID: PLACE_HOLDER_USER_ID,
  SUCCESSFUL_REQUEST_SEND_MAIL: SUCCESSFUL_REQUEST_SEND_MAIL,
  FAILED_REQUEST_SEND_MAIL: FAILED_REQUEST_SEND_MAIL,
  TOKEN_EXPIRED_MESSAGE: TOKEN_EXPIRED_MESSAGE,
  API_FUNCTION_PHASE2: API_FUNCTION_PHASE2,
  ERROR_CODE: ERROR_CODE,
  ERROR_MESSAGE: ERROR_MESSAGE,
  COLLATE_TOKEN_ERROR_MESSAGE: COLLATE_TOKEN_ERROR_MESSAGE,
  RE_REGISTRATION_MISMATCH_ERROR_MESSAGE: RE_REGISTRATION_MISMATCH_ERROR_MESSAGE,
  FAILED_ISSUE_TOKEN: FAILED_ISSUE_TOKEN,
  FAILED_NOT_EMAIL_ADDRESS: FAILED_NOT_EMAIL_ADDRESS,
  INPUT_ORDER_QUENTITY_VALUE: INPUT_ORDER_QUENTITY_VALUE,
  LAST_3_MONTHS: LAST_3_MONTHS,
  LAST_6_MONTHS: LAST_6_MONTHS,
  LAST_9_MONTHS: LAST_9_MONTHS,
  LAST_12_MONTHS: LAST_12_MONTHS,
  RESPONSE_CODE_SUCCESS: RESPONSE_CODE_SUCCESS,
  STATUS_CODE_SUCCESS: STATUS_CODE_SUCCESS,
  POSTAGE_REMARKS: POSTAGE_REMARKS,
  All_DOWNLOAD_MODAL_MESSAGE: All_DOWNLOAD_MODAL_MESSAGE,
  DISPLAY_ITEM_LIST: DISPLAY_ITEM_LIST, 
  COOKIE_SAVE_KEY: COOKIE_SAVE_KEY,  
  PRACTICE_SUPPORT_SEND_SUCCESS_MESSAGE: PRACTICE_SUPPORT_SEND_SUCCESS_MESSAGE,
  PRACTICE_SUPPORT_MACHINE_LIST: PRACTICE_SUPPORT_MACHINE_LIST,
  PRACTICE_SUPPORT_HEADER: PRACTICE_SUPPORT_HEADER,
  COSME_ICON_MODAL_MESSAGE: COSME_ICON_MODAL_MESSAGE,
  SESSION_STORAGE_SAVE_KEY_LOGIN_USER_OBJ: SESSION_STORAGE_SAVE_KEY_LOGIN_USER_OBJ,
  SUCCESS_FIRST_TIME_CHANGE_PASSWORD: SUCCESS_FIRST_TIME_CHANGE_PASSWORD,
  FAILED_FIRST_TIME_CHANGE_PASSWORD: FAILED_FIRST_TIME_CHANGE_PASSWORD,
  TEMPORARY_PASSWORD_INCORRECT: TEMPORARY_PASSWORD_INCORRECT,
  LOGIN_FAILED_CODE_NOT_AUTHORIZED: LOGIN_FAILED_CODE_NOT_AUTHORIZED,  
  DISPLAY_ITEM_SORT: DISPLAY_ITEM_SORT,
  PRODUCT_ITEM_TYPE: PRODUCT_ITEM_TYPE
}



// WEBPACK FOOTER //
// ./src/mixins/delivery-methods.js